// extracted by mini-css-extract-plugin
export default {"rtl":"x95aVd"};